/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { NavigationBarDesktopProps } from "@/src/components/Navigation/NavigationBar/Desktop/NavigationBarDesktop";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import NavigationBarMobileNonAuthenticated from "@/src/components/Navigation/NavigationBar/Mobile/NavigationBarMobileNonAuthenticated";
import NavigationBarMobileAuthenticated from "@/src/components/Navigation/NavigationBar/Mobile/NavigationBarMobileAuthenticated";

type NavigationBarMobileProps = {
  hideActions?: boolean;
  clickableLogo?: boolean;
  mainNavigationItems: NavigationBarDesktopProps["mainNavigationItems"];
};

export default function NavigationBarMobile({ hideActions, mainNavigationItems, clickableLogo = true }: NavigationBarMobileProps) {
  const { customer } = useCustomer();

  if (customer) {
    return <NavigationBarMobileAuthenticated clickableLogo={clickableLogo} />;
  }

  return <NavigationBarMobileNonAuthenticated hideActions={hideActions} mainNavigationItems={mainNavigationItems} clickableLogo={clickableLogo} />;
}
